import { render, staticRenderFns } from "./RulesPlatform.vue?vue&type=template&id=929d5448&"
import script from "./RulesPlatform.vue?vue&type=script&lang=js&"
export * from "./RulesPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports